import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { gendersWithoutNeutral } from "../../../../../shared/definitions/other/Gender";
import { gameStore } from "../../../../stores/GameStore";
import { AutoResizeTextareaFullWidth } from "../../../shared/AutoResizeTextarea";
import { ElementGroup, ElementLabel } from "./BaseElements";
const SimpleInputContainer = styled.div.withConfig({
  displayName: "TranslatedStringActionDetail__SimpleInputContainer",
  componentId: "sc-fjmwp9-0"
})([""]);
/*
const IndentedInputContainer = styled(SimpleInputContainer)`
    margin-top: 4px;
    border-left: 2px solid grey;
    margin-left: 0.5em;
    padding-left: 0.5em;
`;
*/

const CommentArea = styled.div.withConfig({
  displayName: "TranslatedStringActionDetail__CommentArea",
  componentId: "sc-fjmwp9-1"
})(["textarea{border-style:dotted;}opacity:50%;"]);
export const CheckboxedArea = observer(({
  label,
  hasContent,
  children
}) => {
  const {
    t
  } = useTranslation();
  const [show, setShow] = useState(hasContent);
  useEffect(() => {
    if (hasContent && !show) {
      setShow(true);
    }
  }, [hasContent]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    disabled: hasContent,
    checked: show,
    onChange: () => setShow(!show)
  }), " "), label)), show && children);
});
export const GenderedTranslation = observer(({
  gender,
  translatedString
}) => {
  const {
    t
  } = useTranslation();
  const {
    languageKey
  } = gameStore;
  const value = translatedString.getForGender(languageKey, gender, false);
  return /*#__PURE__*/React.createElement(CheckboxedArea, {
    label: t("editor.translation" + gender),
    hasContent: !!value
  }, /*#__PURE__*/React.createElement(AutoResizeTextareaFullWidth, {
    value: value,
    onChange: ({
      target
    }) => translatedString.setForGender(languageKey, gender, target.value)
  }));
});
export let DisplayMode;

(function (DisplayMode) {
  DisplayMode[DisplayMode["Simple"] = 0] = "Simple";
  DisplayMode[DisplayMode["CommentAndGenders"] = 1] = "CommentAndGenders";
})(DisplayMode || (DisplayMode = {}));

export const TranslatedStringActionDetail = observer(({
  name,
  translatedString,
  displayMode,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const {
    languageKey
  } = gameStore;
  const showComment = displayMode !== DisplayMode.Simple;
  const showGenderedVersions = displayMode === DisplayMode.CommentAndGenders; //const InputContainer = (displayMode === DisplayMode.Simple) ? SimpleInputContainer : IndentedInputContainer;

  const InputContainer = SimpleInputContainer;
  return /*#__PURE__*/React.createElement(ElementGroup, null, name && /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(AutoResizeTextareaFullWidth, {
    className: translatedString.get(languageKey, false).length == 0 && !allowBlankValue ? "invalid" : "",
    value: translatedString.get(languageKey, false),
    placeholder: translatedString.get(languageKey, true),
    onChange: ({
      target
    }) => translatedString.set(languageKey, target.value)
  }), showGenderedVersions && gendersWithoutNeutral.map(gender => /*#__PURE__*/React.createElement(GenderedTranslation, {
    key: gender,
    gender: gender,
    translatedString: translatedString
  })), showComment && /*#__PURE__*/React.createElement(CommentArea, null, /*#__PURE__*/React.createElement(CheckboxedArea, {
    label: t("editor.translation_comment"),
    hasContent: !!translatedString.comment
  }, /*#__PURE__*/React.createElement(AutoResizeTextareaFullWidth, {
    value: translatedString.comment,
    onChange: ({
      target
    }) => translatedString.setComment(target.value)
  })))));
});